import { showToast } from "./toast";

/**
 * Copy text to clipboard and show a success toast.
 *
 * @param {string} text  - The text to copy
 * @param {string} label - Human-readable label for the toast (e.g. "Alamat", "Nomor telepon")
 */
export const copyToClipboard = async (text, label = "Teks") => {
    if (!text) return;

    try {
        await navigator.clipboard.writeText(text);
        showToast("success", "Berhasil Disalin", `${label} berhasil disalin.`);
    } catch {
        showToast("error", "Gagal Menyalin", "Tidak dapat menyalin teks.");
    }
};
